import { render, staticRenderFns } from "./CoozzyBuildingIcon.vue?vue&type=template&id=e3ef94de&scoped=true"
import script from "./CoozzyBuildingIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyBuildingIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBuildingIcon.vue?vue&type=style&index=0&id=e3ef94de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef94de",
  null
  
)

export default component.exports